<template>
  <div class="rightBottom">
    <div class="title">金融</div>
    <div class="content">
      <div class="left-list">
        <div class="item">
          <div class="left">授信总额</div>
          <div class="right1" :title="summary.creditAmount || 0 | formatNumber">{{summary.creditAmount || 0 | formatNumber}}<span class="unit">亿</span></div>
        </div>
        <div class="item">
          <div class="left">贷款总额</div>
          <div class="right1" :title="summary.loanAmount || 0 | formatNumber">{{summary.loanAmount || 0 | formatNumber}}<span class="unit">亿</span></div>
        </div>
        <div class="item">
          <div class="left">贷款余额</div>
          <div class="right1" :title="summary.loanBalance || 0 | formatNumber">{{summary.loanBalance || 0 | formatNumber}}<span class="unit">亿</span></div>
        </div>
        <div class="item">
          <div class="left">企业数量</div>
          <div class="right1" :title="summary.loanEnterprisesNum || 0 | formatNumber">{{summary.loanEnterprisesNum || 0 | formatNumber}}<span class="unit">家</span></div>
        </div>
        <div class="item">
          <div class="left">不良率</div>
          <div class="right1" :title="summary.rejectRatio">{{summary.rejectRatio || 0 | isEmptyVal}}%</div>
        </div>
      </div>
      <div class="right">
        <div class="list">
          <div class="item" :class="menuItem.orgLoanRank ? 'setCursor' : ''" @click="showModel">
            <img class="icon" src='@/assets/images/home/icon-qysl.png'/>
            <div class="text">金融机构TOP5</div>
          </div>
          <div class="item" :class="menuItem.orgLoanRank ? 'setCursor' : ''" @click="showModel1">
            <img class="icon" src='@/assets/images/home/icon-qysl.png'/>
            <div class="text">贷款企业TOP5</div>
          </div>
        </div>
        <div class="right-main">
          <div class="left">
            <div class="item" v-for='(item, index) in orgTopSummary' :key="index">
              <el-tooltip
                popper-class="ux-dark-el-tooltip"
                effect="dark"
                placement="top"
                :content="item.orgName"
                :open-delay="300"
                >
                <div class="text">{{item.orgName | isEmptyVal}}</div>
              </el-tooltip>
            </div>
          </div>
          <img src='@/assets/images/home/fc.png'/>
          <div class="right">
            <div class="item" v-for='(item, index) in customerTopSummary' :key="index">
              <el-tooltip
                popper-class="ux-dark-el-tooltip"
                effect="dark"
                placement="top"
                :content="item.customerName"
                :open-delay="300"
                >
                <div class="text">{{item.customerName}}</div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- <div id="rightBottom-charts"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const {mapState, mapMutations} = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        orgLoanRank: false // 金融机构贷款总额TOP排名
      },
      customerTopSummary: [],
      orgTopSummary: [],
      summary: {},
      initObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.orgLoanRank = common.isShowItem('orgLoanRank', setListMenu)
    }
  },

  mounted () {
    this.init()
    this.initObj = setInterval(() => {
      this.init()
    }, 60000)
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    async init () {
      this.loadFinancialOrgLoansSum()
      this.loadFinancialOrgLoans()
      this.loadFinancialEnterpriseLoans()
    },
    // 统计
    loadFinancialOrgLoansSum () {
      this.$ajax({
        method: 'get',
        url: apiPath.bigData.home.rightBottom.financialOrgLoansSum
      }).then(res => {
        if (res) {
          this.summary = res.data || {}
          this.summary.creditAmount = (res.data.creditAmount / 100000000).toFixed(2)
          this.summary.loanBalance = (res.data.loanBalance / 100000000).toFixed(2)
          this.summary.loanAmount = (res.data.loanAmount / 100000000).toFixed(2)
        }
      })
    },
    // 表左
    loadFinancialOrgLoans () {
      this.$ajax({
        method: 'get',
        url: apiPath.bigData.home.rightBottom.getFinancialOrgLoans,
        params: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(res => {
        if (res) {
          this.orgTopSummary = res.data || []
        }
      })
    },
    // 表右
    loadFinancialEnterpriseLoans () {
      this.$ajax({
        method: 'get',
        url: apiPath.bigData.home.rightBottom.getFinancialEnterpriseLoans,
        params: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(res => {
        if (res) {
          this.customerTopSummary = res.data || []
        }
      })
    },
    initCharts () {
      var chartDom = document.getElementById('rightBottom-charts')
      var myChart = this.$echarts.init(chartDom)
      var option
      option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}%'
        },
        toolbox: {
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        },
        // legend: {
        //   data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order']
        // },
        series: [
          {
            name: 'Funnel',
            type: 'funnel',
            left: 16,
            top: 0,
            right: 0,
            bottom: 60,
            width: '80%',
            min: 0,
            max: 100,
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            label: {
              show: true,
              position: 'inside'
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            data: [
              { value: 60, name: 'Visit' },
              { value: 40, name: 'Inquiry' },
              { value: 20, name: 'Order' },
              { value: 80, name: 'Click' },
              { value: 100, name: 'Show' }
            ]
          }
        ]
      }
      option && myChart.setOption(option)
    },
    showModel () {
      if (!this.menuItem.orgLoanRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'listFinanceStatisticsOfOrg',
        method: 'post',
        title: '金融机构贷款总额TOP排名',
        headList: [
          {
            name: '授信总额',
            value: that.summary.creditAmount || '0',
            unit: '（亿）'
          }, {
            name: '贷款总额',
            value: that.summary.loanAmount || '0',
            unit: '（亿）'
          }, {
            name: '贷款余额',
            value: that.summary.loanBalance || '0',
            unit: '（亿）'
          }, {
            name: '企业数量',
            value: that.summary.loanEnterprisesNum || '0',
            unit: '（家）'
          }, {
            name: '不良率',
            value: that.summary.rejectRatio || '0%',
            unit: ''
          }
        ],
        model: true
      })
    },
    showModel1 () {
      if (!this.menuItem.orgLoanRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'listFinanceStatisticsOfCompany',
        method: 'post',
        title: '贷款企业总额TOP排名',
        headList: [
          {
            name: '授信总额',
            value: that.summary.creditAmount || '0',
            unit: '（亿）'
          }, {
            name: '贷款总额',
            value: that.summary.loanAmount || '0',
            unit: '（亿）'
          }, {
            name: '贷款余额',
            value: that.summary.loanBalance || '0',
            unit: '（亿）'
          }, {
            name: '机构数量',
            value: that.summary.orgNum || '0',
            unit: '（家）'
          }, {
            name: '不良率',
            value: that.summary.rejectRatio || '0%',
            unit: ''
          }
        ],
        model: true
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
  .rightBottom{
    width: 454px;
    height: 214px;
    background: url('~@/assets/images/home/title-bg.png') no-repeat 0 0;
    background-size:100% 100%;
    .title{
      height: 18px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #00FAFF;
      width: 100%;
      line-height: 18px;
      margin-top: 10px;
      text-align: center;
    }
    .content{
      display: flex;
      .left-list{
        margin-left:20px;
        width: 126px;
        margin-top:20px;
        .item{
          display: flex;
          justify-content: space-between;
          padding: 0 8px;
          background: linear-gradient(to right,rgb(47, 92,146), transparent);
          border-left:2px solid #fff;
          height: 20px;
          line-height: 20px;
          margin-bottom:12px;
          .left{
            font-size: 11px;
          }
          .right1{
            font-size: 14px;
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            .unit{
              font-size: 10px;
            }
          }
        }
      }
      .right{
        // width: 220px;
        margin-left:16px;
        margin-right:24px;
        flex:1;
        .list{
          display: flex;
          justify-content: space-between;
          margin:16px 0 10px 8px;
          .item{
            display: flex;
            align-items: center;
            .icon{
              width: 34px;
              height:34px;
            }
            .text{
              font-size:10px;
            }
          }
        }
        .right-main{
          display: flex;
          width:100%;
          justify-content: space-between;
          // align-items: center;
          height:120px;
          font-size: 10px;
          line-height: 20px;
          .item{
            width: 50px;
            overflow: hidden; //超出的文本隐藏
            word-break:keep-all;white-space:nowrap;
            text-overflow: ellipsis; //溢出用省略号显示
          }
          .text{
            width: 50px;
            overflow: hidden; //超出的文本隐藏
            word-break:keep-all;white-space:nowrap;
            text-overflow: ellipsis; //溢出用省略号显示
            line-height:18px;
          }
          .left{
            margin-top:3px;
          }
          .right{
            margin:0;
            margin-top:11px;
            text-align: right;
          }
        }
        img{
          width: 154px;
          height:80px;
        }
      }
    }
    #rightBottom-charts{
      margin:16px 0 0 0;
      width:290px;
      height:166px;
    }
    .ux-dark-el-tooltip{
      width:150px;
    }
  }
</style>
<style>
  .el-tooltip__popper{
    min-width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/rightBottom.vue